/* AeroSims FX display-currency layer.
 * Billing is ALWAYS USD (Shopify Payments blocked -> platform allows USD only);
 * this converts DISPLAYED prices using daily rates from the Sky worker /fx.json.
 * Currency is chosen in the locale modal (data-fx tiles) -> localStorage asFxCur.
 * Guards: blog pages skipped (price-index study quotes must stay USD),
 * "$" preceded by a letter skipped (A$/CA$/MX$ = already-converted output).
 * 7.9.2026: switching no longer reloads the page. Every converted text node keeps its
 * USD original in a WeakMap; asFxSet() restores the originals and re-converts with the
 * new rate (or leaves USD). Only blog pages still reload (they are never converted). */
(function(){
  'use strict';
  if (window.__asfx) return; window.__asfx = 1;
  var KEY = 'asFxCur';
  var cur = null;
  try { cur = localStorage.getItem(KEY); } catch (e) {}
  if (!cur || cur === 'USD') cur = 'USD';
  window.asFxCur = cur;
  var isBlog = location.pathname.indexOf('/blogs/') !== -1;

  function pills(){ return document.querySelectorAll('#esim-currency, .esim-fx-pill'); }

  var lang = (document.documentElement.lang || 'en');
  var NOTE_TPL = ({
    de:'Angezeigte {C}-Preise sind Richtwerte (Tageskurs). Abgerechnet wird in USD; PayPal bzw. deine Bank rechnet automatisch um.',
    en:'Prices shown in {C} are approximate (daily rate). You are billed in USD; PayPal or your bank converts automatically.',
    es:'Los precios en {C} son orientativos (tipo del día). El cobro es en USD; PayPal o tu banco convierte automáticamente.',
    fr:'Les prix affichés en {C} sont indicatifs (taux du jour). La facturation est en USD ; PayPal ou votre banque convertit automatiquement.',
    it:'I prezzi in {C} sono indicativi (tasso del giorno). L\'addebito è in USD; PayPal o la tua banca converte automaticamente.',
    pt:'Os preços em {C} são aproximados (taxa do dia). A cobrança é em USD; o PayPal ou seu banco converte automaticamente.',
    ru:'Цены в {C} приблизительные (курс дня). Оплата в USD; PayPal или ваш банк конвертирует автоматически.',
    tr:'{C} olarak gösterilen fiyatlar yaklaşıktır (günlük kur). Tahsilat USD yapılır; PayPal veya bankanız otomatik çevirir.',
    ja:'{C}表示の価格は目安です（当日レート）。請求はUSDで行われ、PayPalまたは銀行が自動換算します。',
    zh:'以{C}显示的价格为参考价（当日汇率）。实际以美元结算，PayPal 或您的银行会自动换算。',
    ar:'الأسعار المعروضة بـ {C} تقريبية (سعر اليوم). تتم الفوترة بالدولار الأمريكي؛ يحوّل PayPal أو بنكك تلقائيًا.',
    hi:'{C} में दिखाई कीमतें अनुमानित हैं (आज की दर)। बिलिंग USD में होती है; PayPal या आपका बैंक स्वतः बदल देता है।',
    ko:'{C}로 표시된 가격은 참고용입니다(당일 환율). 결제는 USD로 청구되며 PayPal 또는 은행이 자동 환전합니다.',
    pl:'Ceny w {C} są orientacyjne (kurs dzienny). Płatność pobierana jest w USD; PayPal lub Twój bank przeliczy automatycznie.',
    nl:'Prijzen in {C} zijn indicatief (dagkoers). Afgerekend wordt in USD; PayPal of je bank rekent automatisch om.',
    'zh-tw':'以 {C} 顯示的價格為約略值（依當日匯率換算）。實際以美元（USD）結帳，付款時 PayPal 或你的銀行會自動換匯。',
    he:'המחירים המוצגים ב-{C} הם משוערים (שער יומי). החיוב בדולר אמריקאי; PayPal או הבנק ימירו אוטומטית.',
    id:'Harga dalam {C} bersifat perkiraan (kurs harian). Penagihan dalam USD; PayPal atau bank Anda mengonversi otomatis.',
    sr:'Cene u {C} su okvirne (dnevni kurs). Naplata je u USD; PayPal ili vaša banka automatski konvertuje.',
    sq:'Çmimet në {C} janë të përafërta (kursi ditor). Faturimi bëhet në USD; PayPal ose banka jote e konverton automatikisht.'
  }[/^zh-(tw|hant|hk)/.test(lang.toLowerCase())?'zh-tw':lang.toLowerCase().slice(0,2)] || 'Prices shown in {C} are approximate (daily rate). You are billed in USD; PayPal or your bank converts automatically.');
  var NOTE = '';

  var rate = 0, fmt = null, rates = null, mo = null;
  var orig = (typeof WeakMap === 'function') ? new WeakMap() : null; // text node -> USD original
  var touched = [];                                                    // converted nodes (for restore)
  function fmtV(v){
    if (fmt) { try { return fmt.format(v); } catch (e) {} }
    return cur + ' ' + v.toFixed(2);
  }

  var RX = /\$\s?(\d{1,3}(?:,\d{3})+(?:\.\d{1,2})?|\d+(?:\.\d{1,2})?)(\s?USD\b)?/g;
  function convText(s){
    return s.replace(RX, function(m, num, usd, off){
      var prev = off > 0 ? s.charAt(off - 1) : '';
      if (prev && /[A-Za-z]/.test(prev)) return m; // A$/CA$/MX$ etc. = already converted
      var v = parseFloat(num.replace(/,/g, ''));
      if (!isFinite(v)) return m;
      return fmtV(v * rate);
    });
  }

  var SKIP = { SCRIPT:1, STYLE:1, INPUT:1, TEXTAREA:1, SELECT:1, NOSCRIPT:1 };
  function eligible(node){
    var p = node.parentNode;
    if (!p || p.nodeType !== 1 || SKIP[p.nodeName]) return false;
    if (p.closest && p.closest('.asfx-skip')) return false;
    return true;
  }
  function remember(n, t){
    if (!orig) return;
    if (!orig.has(n)) touched.push(n);
    orig.set(n, t); // any text carrying "$" is a fresh USD original (converted text never contains "$")
  }
  function convNode(n){
    var t = n.nodeValue;
    if (!t || t.indexOf('$') === -1 || !/\$\s?\d/.test(t)) return;
    if (!eligible(n)) return;
    var nt = convText(t);
    if (nt !== t) { remember(n, t); n.nodeValue = nt; }
  }
  function walk(root){
    if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n, hits = [];
    while ((n = w.nextNode())) {
      if (n.nodeValue && n.nodeValue.indexOf('$') !== -1) hits.push(n);
    }
    for (var i = 0; i < hits.length; i++) convNode(hits[i]);
  }
  function restoreAll(){
    // put every converted text node back to its USD original (nodes removed from the DOM are harmless)
    for (var i = 0; i < touched.length; i++) {
      var n = touched[i]; var o = orig && orig.get(n);
      if (typeof o === 'string' && n.nodeValue !== o) n.nodeValue = o;
    }
    touched = []; if (orig) orig = new WeakMap();
    var usd = document.querySelectorAll('[data-asfx-usd]');
    for (var k = 0; k < usd.length; k++) { var el = usd[k]; el.textContent = el.getAttribute('data-asfx-usd'); el.removeAttribute('data-asfx-usd'); }
  }

  function addCartNote(){
    if (!/^(?:\/[a-z]{2}(?:-[a-zA-Z]+)?)?\/cart\/?$/.test(location.pathname)) return;
    var tries = 0;
    var iv = setInterval(function(){
      var ex = document.getElementById('asfx-note');
      if (ex) { ex.textContent = NOTE; clearInterval(iv); return; }
      var btn = document.querySelector('button[name="checkout"], #checkout, .cart__checkout-button, a[href$="/checkout"]');
      if (btn && btn.parentNode) {
        clearInterval(iv);
        var d = document.createElement('div');
        d.id = 'asfx-note'; d.className = 'asfx-skip';
        d.style.cssText = 'margin-top:10px;font-size:12px;line-height:1.55;color:#8ea2c0;text-align:center;';
        d.textContent = NOTE;
        btn.parentNode.insertBefore(d, btn.nextSibling);
      } else if (++tries > 25) clearInterval(iv);
    }, 400);
  }
  function removeCartNote(){ var d = document.getElementById('asfx-note'); if (d && d.parentNode) d.parentNode.removeChild(d); }

  function fixUsdToken(el){
    // header "USD / EN" label + drawer: swap the USD token for the display currency
    // (text-node level so the caret svg/child elements survive)
    try {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) {
        var o = (orig && orig.get(n)) || n.nodeValue;
        if (o && o.indexOf('USD') !== -1) {
          var nv = o.replace(/\bUSD\b/g, cur);
          if (nv !== n.nodeValue) { remember(n, o); n.nodeValue = nv; }
        }
      }
    } catch (e) {}
  }
  function syncPill(){
    var ps = pills();
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i];
      if (p.textContent !== cur) p.textContent = cur;
      if (p.title !== NOTE) p.title = NOTE;
    }
    if (cur === 'USD') return;
    var btns = document.querySelectorAll('.dropdown-localization__button, .drawer-localization__button, .mobile-localization, .currency-code');
    for (var b = 0; b < btns.length; b++) fixUsdToken(btns[b]);
  }

  function observe(){
    if (mo) return;
    mo = new MutationObserver(function(muts){
      if (cur === 'USD' || !rate) return;
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'characterData') { convNode(m.target); continue; }
        if (m.addedNodes) {
          for (var k = 0; k < m.addedNodes.length; k++) {
            var a = m.addedNodes[k];
            if (a.nodeType === 3) convNode(a);
            else if (a.nodeType === 1 && !SKIP[a.nodeName]) walk(a);
          }
        }
      }
      syncPill();
    });
    mo.observe(document.documentElement, { childList:true, subtree:true, characterData:true });
  }

  function applyCurrent(){
    // (re)convert the whole page for `cur`; call after restoreAll() when switching
    NOTE = NOTE_TPL.replace('{C}', cur);
    try { fmt = new Intl.NumberFormat(lang, { style:'currency', currency:cur }); } catch (e) { fmt = null; }
    walk(document.body);
    syncPill();
    addCartNote();
    observe();
  }
  function applyUsd(){
    rate = 0; fmt = null; NOTE = '';
    restoreAll();
    removeCartNote();
    var ps = pills();
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i];
      if (p.textContent !== 'USD') p.textContent = 'USD';
      if (/automatically in your local currency/i.test(p.title || '') || p.title) p.title = '';
    }
  }

  function withRates(cb){
    var c = null;
    try { c = JSON.parse(sessionStorage.getItem('asFxRates') || 'null'); } catch (e) { c = null; }
    if (c && c.rates && (Date.now() - (c.t0 || 0)) < 6 * 3600 * 1000) { rates = c.rates; cb(rates); return; }
    fetch('https://aerosims-support-agent.aerosims-esim.workers.dev/fx.json')
      .then(function(r){ return r.json(); })
      .then(function(j){
        if (!j || !j.rates) { cb(null); return; }
        try { sessionStorage.setItem('asFxRates', JSON.stringify({ t0: Date.now(), rates: j.rates })); } catch (e) {}
        rates = j.rates; cb(rates);
      })
      .catch(function(){ cb(null); /* rates unavailable -> USD display, still correct */ });
  }

  function switchTo(c){
    c = (c && String(c).toUpperCase()) || 'USD';
    if (c === cur && (c === 'USD' || rate)) return;
    if (c === 'USD') { cur = 'USD'; window.asFxCur = cur; applyUsd(); return; }
    withRates(function(r){
      if (!r || !r[c]) { cur = 'USD'; window.asFxCur = cur; applyUsd(); return; } // unknown currency -> silently stay USD
      if (rate) restoreAll();          // undo the previous currency first (originals are USD)
      cur = c; window.asFxCur = cur; rate = r[c];
      applyCurrent();
    });
  }

  window.asFxSet = function(c){
    c = (c && String(c).toUpperCase()) || 'USD';
    try {
      if (c === 'USD') localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, c);
    } catch (e) {}
    if (isBlog) { location.reload(); return; }
    if (document.body) switchTo(c);
    else document.addEventListener('DOMContentLoaded', function(){ switchTo(c); });
  };

  function start(){
    if (cur === 'USD') { applyUsd(); return; }
    withRates(function(r){
      if (!r || !r[cur]) return; // unknown currency -> USD display
      rate = r[cur];
      applyCurrent();
    });
  }
  if (isBlog) {
    // blog pages: never converted; only keep the pill honest
    document.addEventListener('DOMContentLoaded', function(){ var ps = pills(); for (var i = 0; i < ps.length; i++) ps[i].title = ''; });
    return;
  }
  if (document.body && document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
